import { Input } from '@enterprise-ui/canvas-ui-react';
import classnames from 'classnames';
import React__default from 'react';
import { usePagination } from '../Pagination/utils/hooks.js';
import { MULTIPLE_ROW_SELECT, SINGLE_ROW_SELECT } from './constants.js';
import { getSelectAllStatus, getAllSelectedRows } from './helpers.js';

var SelectionCellAll = function SelectionCellAll(_ref) {
  var dataTestId = _ref.dataTestId,
    displayData = _ref.displayData,
    isResizable = _ref.isResizable,
    onRowSelect = _ref.onRowSelect,
    rowSelection = _ref.rowSelection,
    selectedRows = _ref.selectedRows,
    tableName = _ref.tableName;
  var _usePagination = usePagination(),
    _usePagination$state = _usePagination.state,
    isClient = _usePagination$state.isClient,
    itemRange = _usePagination$state.itemRange;
  var selectAllEnabled = rowSelection === MULTIPLE_ROW_SELECT;
  var selectionEnabled = rowSelection === SINGLE_ROW_SELECT || selectAllEnabled;

  // only allow rows that are in view to be selectable
  var selectableRows = isClient ? displayData.slice(itemRange.start - 1, itemRange.end) : displayData;
  var _getSelectAllStatus = getSelectAllStatus(selectedRows, selectableRows),
    isSelectAllChecked = _getSelectAllStatus.isSelectAllChecked,
    isIntermediate = _getSelectAllStatus.isIntermediate;
  var onCheckboxChange = function onCheckboxChange(checked) {
    onRowSelect(getAllSelectedRows({
      checked: checked,
      selectableRows: selectableRows,
      selectedRows: selectedRows
    }));
  };
  var columnClasses = classnames('C-TableAdvanced__headerCell', 'selectAllCell', {
    isResizable: isResizable
  });
  return selectionEnabled && /*#__PURE__*/React__default.createElement("div", {
    className: columnClasses,
    scope: "col",
    role: "columnheader",
    "data-testid": dataTestId ? "".concat(dataTestId, "-selection-cell-all") : null
  }, selectAllEnabled && /*#__PURE__*/React__default.createElement(Input.Checkbox, {
    checked: isSelectAllChecked,
    "data-testid": dataTestId ? "".concat(dataTestId, "-selection-cell-all-checkbox") : null,
    id: "".concat(tableName, "-select-all-rows"),
    indeterminate: isIntermediate,
    onChange: function onChange(event) {
      onCheckboxChange(event.target.checked);
    }
  }));
};

export { SelectionCellAll as default };
